import React, { useState, useEffect } from "react";
import axios from 'axios';
import './DetailsofProfile.css';
import Select from 'react-select';
import DatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css';

const DetailsofProfile = ({ onNext }) => {
  const [jobOpenings, setJobOpenings] = useState([]);
  const [basedOnJobId, setBasedOnJobId] = useState([]);
  const [jobId, setJobId] = useState(null); // Track selected job ID
  const [formData, setFormData] = useState(() => {
    const saved = localStorage.getItem('formData');
    return saved ? JSON.parse(saved) : {
      surName: '',
      name: '',
      guardianName: '',
      relationship: '',
      gender: '',
      bDay: '',
      mobileNumber: '',
      email: '',
      maritalStatus: '',
      nationality: null,
      religion: null,
      handicapped: '',
      hearing: '',
      visual: '',
      employeePhoto: null,
    };
  });
  const [isFocused, setIsFocused] = useState(false);
  const isJobLabelFloated = isFocused || jobId;
  const [isNationalityFocused, setIsNationalityFocused] = useState(false);
  const isNationalityLabelFloated = isNationalityFocused || formData.nationality;
  const [IsReligionFocused, setIsReligionFocused] = useState(false);
  const isReligionLabelFloated = IsReligionFocused || formData.religion;
  const [formErrors, setFormErrors] = useState({});
  const validate = () => {
    const errors = {};

    if (!formData.surName.trim()) {
      errors.surName = "Surname is required";
    } else if (!/^[A-Za-z\s]+$/.test(formData.surName)) {
      errors.surName = "Surname can only contain letters and spaces";
    }

    if (!formData.name.trim()) {
      errors.name = "Name is required";
    } else if (!/^[A-Za-z\s]+$/.test(formData.name)) {
      errors.name = "Name can only contain letters and spaces";
    }

    if (!formData.bDay) {
      errors.bDay = "Date of Birth is required";
    } else if (new Date(formData.bDay) > new Date()) {
      errors.bDay = "Date of Birth cannot be in the future";
    }

    if (!formData.mobileNumber.trim()) {
      errors.mobileNumber = "Contact Number is required";
    } else if (!/^\d{10}$/.test(formData.mobileNumber)) {
      errors.mobileNumber = "Contact Number must be 10 digits";
    }

    if (!formData.email.trim()) {
      errors.email = "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      errors.email = "Email is invalid";
    }

    setFormErrors(errors);

    // return true if no errors
    return Object.keys(errors).length === 0;
  };
  useEffect(() => {
    if (jobOpenings.length === 0) return; // wait till jobOpenings loaded

    const savedJobId = localStorage.getItem('selectedJobId');
    if (savedJobId) {
      // Check if savedJobId exists in jobOpenings (compare as strings)
      const exists = jobOpenings.some(job => String(job.jobId) === String(savedJobId));
      if (exists) {
        setJobId(savedJobId);
      } else {
        setJobId(null);
        localStorage.removeItem('selectedJobId');
      }
    }
  }, [jobOpenings]);
  useEffect(() => {
    if (formData.bDay && typeof formData.bDay === 'string') {
      setFormData(prev => ({
        ...prev,
        bDay: new Date(formData.bDay),
      }));
    }
  }, []);


  const [nationalities, setNationalities] = useState([]);
  const [religions, setReligions] = useState([]);


  const isFormValid = () => {
    const { surName, name, bDay, mobileNumber, email, nationality } = formData;
    const isValidMobile = /^\d{10}$/.test(mobileNumber);
    const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

    return (
      surName.trim() &&
      name.trim() &&
      bDay &&
      isValidMobile &&
      isValidEmail &&
      nationality
    );
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));

  };
  const handleInputChange = (eOrOption, fieldName) => {
    if (eOrOption && eOrOption.target) {
      const { name, value } = eOrOption.target;
      setFormData(prev => ({
        ...prev,
        [name]: value,
      }));
    } else {
      const value = eOrOption ? eOrOption.value : '';
      setFormData(prev => ({
        ...prev,
        [fieldName]: value,
      }));
    }
  };


  const handleSubmit = (e) => {
    e.preventDefault();

    if (validate()) {
      console.log('Form submitted successfully:', formData);
      onNext();
    } else {
      console.log('Validation errors:', formErrors);
    }
  };


  useEffect(() => {
    const fetchAllJobs = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/job-openings`);
        setJobOpenings(response.data);
      } catch (error) {
        console.error("Error fetching job openings:", error);
      }
    };
    fetchAllJobs();
  }, []);


  const fetchJobBasedOnId = async (jobId) => {
    if (!jobId) return;
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/job-openings/${jobId}`);
      setBasedOnJobId(response.data);
    } catch (error) {
      console.error("Error fetching job by ID:", error);
    }
  };


  useEffect(() => {
    fetchJobBasedOnId(jobId);
  }, [jobId]);
  useEffect(() => {
    localStorage.setItem('formData', JSON.stringify(formData));
  }, [formData]);

  useEffect(() => {
    const fetchNationalities = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/nationality`);
        const data = await response.json();
        if (Array.isArray(data)) {
          setNationalities(data);
          const formatted = data.map((nat) => ({
            value: nat.Nationality_NAME,
            label: nat.Nationality_NAME,
          }));
          setNationalities(formatted);
        } else {
          console.error('Invalid response format: nationalities should be an array');
        }
      } catch (error) {
        console.error('Error fetching nationalities:', error);
      }
    };
    fetchNationalities();
  }, []);

  useEffect(() => {
    const fetchReligions = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/religion`);
        const data = await response.json();
        if (Array.isArray(data)) {
          setReligions(data);
          const formatted = data.map((reg) => ({
            value: reg.Religion_NAME,
            label: reg.Religion_NAME,
          })) // Set the fetched religions in state
          setReligions(formatted);
        } else {
          console.error('Invalid response format: religions should be an array');
        }
      } catch (error) {
        console.error('Error fetching religions:', error);
      }
    };

    fetchReligions();
  }, []);


  const handleFileChange = (e, fieldName) => {
    const file = e.target.files[0];
    if (file) {
      setFormData((prevData) => ({
        ...prevData,
        [fieldName]: file,
      }));

      if (!window._uploadedFiles) {
        window._uploadedFiles = {};
      }
      window._uploadedFiles[fieldName] = file;


      localStorage.setItem("formData", JSON.stringify({
        ...formData,
        [fieldName]: file.name,
      }));
    }
  };
  useEffect(() => {
    const savedJobId = localStorage.getItem('selectedJobId');
    if (savedJobId) {
      setJobId(savedJobId);
    }
  }, []);
  useEffect(() => {
    if (formData.bDay && typeof formData.bDay === 'string') {
      setFormData(prev => ({
        ...prev,
        bDay: new Date(formData.bDay),
      }));
    }
  }, []);


  const handleJobChange = (selectedOption) => {
    const selectedJobId = selectedOption ? selectedOption.value : null;
    setJobId(selectedJobId);
    if (selectedJobId) {
      localStorage.setItem('selectedJobId', selectedJobId);
    } else {
      localStorage.removeItem('selectedJobId');
    }
  };
  return (
    <div className="detailsofprofile-box">
      <h2 className="detailsofprofile-heading">Details</h2>
      <form onSubmit={handleSubmit}>
        <div className="detailsofprofile-maincontainer">
          <div className="detailsofprofile-container-part">
            <div className="did-floating-label-content-select">
              <label className={`did-floating-label-select ${isJobLabelFloated ? 'label-float-select' : ''}`}>
                <span className="label-text-select">Job ID</span>
              </label>
              <Select
                options={jobOpenings.map(job => ({
                  value: job.jobId,
                  label: `${job.jobId} - ${job.positionName}`
                }))}
                value={jobOpenings.find(job => String(job.jobId) === String(jobId)) ? {
                  value: jobId,
                  label: `${jobId} - ${jobOpenings.find(job => String(job.jobId) === String(jobId)).positionName}`
                } : null}
                onChange={handleJobChange}
                onFocus={() => setIsFocused(true)}
                onBlur={() => setIsFocused(false)}
                classNamePrefix="react-select"
                placeholder=" " // important to trigger float logic
              />
              {formErrors.jobId && <div className="error">{formErrors.jobId}</div>}
            </div>

            <div className={`did-floating-label-content ${formErrors.surName ? 'did-error-input' : ''}`}>
              <input type="text" name="surName" value={formData.surName}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^[a-zA-Z\s]*$/.test(value)) { handleChange(e); }
                }}
                className="did-floating-input" placeholder=" " />
              <label className="did-floating-label"><span className="label-text">SurName</span></label>
              {formErrors.surName && <div className="error">{formErrors.surName}</div>}
            </div>

            <div className={`did-floating-label-content ${formErrors.name ? 'did-error-input' : ''}`}>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^[a-zA-Z\s]*$/.test(value)) { handleChange(e); }
                }}
                className="did-floating-input"
                placeholder=" " // required for label to float
              />
              <label className="did-floating-label">Name</label>
              {formErrors.name && <div className="error">{formErrors.name}</div>}
            </div>

            <div className={`did-floating-label-content ${formErrors.guardianName ? 'did-error-input' : ''}`}>
              <input type="text" className="did-floating-input" name="guardianName" value={formData.guardianName}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^[a-zA-Z\s]*$/.test(value)) { handleChange(e); }
                }} placeholder=" " />
              <label className="did-floating-label"><span className="label-text">Guardian&nbsp;Name</span></label>
            </div>
            <div className={`did-floating-label-content ${formErrors.guardianName ? 'did-error-input' : ''}`}>
              <input type="text" className="did-floating-input" name="relationship" value={formData.relationship} onChange={handleChange} placeholder=" " />
              <label className="did-floating-label"><span className="label-text">Relationship</span></label>
            </div>
            <div className="detailsofprofile-input-container-radio">
              <label>Gender</label>
              <label>
                <input type="radio" name="gender" value="male" checked={formData.gender === 'male'}
                  onChange={handleChange} />Male</label>
              <label>
                <input type="radio" name="gender" value="female" checked={formData.gender === 'female'}
                  onChange={handleChange} />Female</label>
              <label>
                <input type="radio" name="gender" value="other" checked={formData.gender === 'other'}
                  onChange={handleChange} /> Other</label>

            </div>
            <div className={`did-floating-label-content ${formErrors.bDay ? 'did-error-input' : ''} ${formData.bDay ? 'filled' : ''}`}>
              <DatePicker
                selected={formData.bDay ? new Date(formData.bDay) : null}
                onChange={(date) => {
                  const bDay = date ? date.toISOString().split('T')[0] : '';
                  setFormData((prev) => {
                    const updated = { ...prev, bDay };
                    localStorage.setItem("formData", JSON.stringify(updated));
                    return updated;
                  });
                }}
                dateFormat="yyyy-MM-dd"
                maxDate={new Date()}
                placeholderText=""
                className="did-floating-input no-placeholder"
              />
              <label className="did-floating-label">
                <span className="label-text">Date&nbsp;of&nbsp;Birth</span>
              </label>
              {formErrors.bDay && <div className="error">{formErrors.bDay}</div>}
            </div>
            <div className="detailsofprofile-input-containers-file">
              <label>Employee Photo:</label>
              <input type="file" name="employeePhoto" onChange={(e) => handleFileChange(e, 'employeePhoto')} required />
            </div>
          </div>
          <div className="detailsofprofile-container-part">

            <div className={`did-floating-label-content ${formErrors.name ? 'did-error-input' : ''}`}>

              <input type="text" maxLength={10} className="did-floating-input" placeholder=" " name="mobileNumber" value={formData.mobileNumber} onChange={handleChange} required />
              <label className="did-floating-label"><span className="label-text">Contact&nbsp;Number</span></label>
              {formErrors.mobileNumber && <div className="error">{formErrors.mobileNumber}</div>}

            </div>
            <div className={`did-floating-label-content ${formErrors.name ? 'did-error-input' : ''}`}>

              <input type="email" className="did-floating-input" name="email" value={formData.email} placeholder=" " onChange={handleChange} required />
              <label className="did-floating-label"><span className="label-text">Email&nbsp;Address</span></label>
              {formErrors.email && <div className="error">{formErrors.email}</div>}
            </div>
            <div className="detailsofprofile-input-container-radio">
              <label>Marital Status</label>
              <label><input type="radio" name="maritalStatus" value="single" checked={formData.maritalStatus === "single"} onChange={handleChange} /> Single</label>
              <label><input type="radio" name="maritalStatus" value="married" checked={formData.maritalStatus === "married"} onChange={handleChange} /> Married</label>
            </div>
            <div className="did-floating-label-content-select">
              <label className={`did-floating-label-select ${isNationalityLabelFloated ? 'label-float-select' : ''}`}>
                <span className="label-text-select">Nationality:</span>
              </label>
              <Select
                name="nationality"
                options={nationalities}
                value={nationalities.find(opt => opt.value === formData.nationality) || null}
                onChange={(selectedOption) => handleInputChange(selectedOption, 'nationality')}
                onFocus={() => setIsNationalityFocused(true)}
                onBlur={() => setIsNationalityFocused(false)}
                classNamePrefix="react-select"
                placeholder=" "
                isClearable
              />
            </div>

            <div className="did-floating-label-content-select">
              <label className={`did-floating-label-select ${isReligionLabelFloated ? 'label-float-select' : ''}`}><span className="label-text-select">Religion:</span></label>
              <Select name="religion" options={religions} value={religions.find(opt => opt.value === formData.religion) || null}
                onChange={(selectedOption) => handleInputChange(selectedOption, 'religion')}
                classNamePrefix="react-select" placeholder=" "
                onFocus={() => setIsReligionFocused(true)}
                onBlur={() => setIsReligionFocused(false)}
                isClearable />
            </div>
            <div className="detailsofprofile-input-container-radio">
              <label>Physically Handicapped</label>
              <label><input type="radio" name="handicapped" value="yes" checked={formData.handicapped === "yes"} onChange={handleChange} /> Yes</label>
              <label><input type="radio" name="handicapped" value="no" checked={formData.handicapped === "no"} onChange={handleChange} /> No</label>
            </div>
            <div className="detailsofprofile-input-container-radio">
              <label>Hearing Problem</label>
              <label><input type="radio" name="hearing" value="yes" onChange={handleChange} checked={formData.hearing === "yes"} /> Yes</label>
              <label><input type="radio" name="hearing" value="no" onChange={handleChange} checked={formData.hearing === "no"} /> No</label>
            </div>
            <div className="detailsofprofile-input-container-radio">
              <label>Visual Problem</label>
              <label><input type="radio" name="visual" value="yes" checked={formData.visual === "yes"} onChange={handleChange} /> Yes</label>
              <label><input type="radio" name="visual" value="no" checked={formData.visual === "no"} onChange={handleChange} /> No</label>
            </div>
            <div className="detailsofprofile-btn-div">
              <button type="submit" className="detailsofprofile-btn" onClick={handleSubmit} disabled={!isFormValid()}>Next</button>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default DetailsofProfile;
